import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Educator = ApplicationRecord.extend({
  static: {
    jsonapiType: 'educators',
  },
  attrs: {
    name: attr(),
    grade: attr(),
    displayName: attr(),
    displayGrade: attr(),
    student: belongsTo(),
    school: belongsTo(),
  },
})

export default Educator
